module.exports = __webpack_public_path__ + "static/img/introduce.8b87f46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduce.jpg
// module id = i9qz
// module chunks = 0